export default __webpack_public_path__ + "static/media/notification.21c6d6a1.svg";